// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-bordered td[data-v-7ca6acc6],\n.table-bordered th[data-v-7ca6acc6] {\n  border: 1px solid #c2c2c2;\n}\ntd[data-v-7ca6acc6],\nth[data-v-7ca6acc6] {\n  vertical-align: middle;\n}\n.item2[data-v-7ca6acc6] {\n  padding-top: 5px;\n}\n.item2[data-v-7ca6acc6]:last-child {\n  border: 0 !important;\n}\n.item2[data-v-7ca6acc6]:hover {\n  background: rgba(239, 239, 239, 0.28);\n}", ""]);
// Exports
module.exports = exports;
